import { useQuery } from '@apollo/client/react'
import { GET_KEYWORD_RANKINGS } from '@/lib/operations/dashboard'
import type { KeywordRanking } from '@/lib/types'

export function useKeywordRankings(
  clientId: string | null,
  locationId?: string | null,
  filters?: { keywords?: string[]; startDate?: string; endDate?: string }
) {
  const { data, loading, error } = useQuery<{ keywordRankings: KeywordRanking[] }>(GET_KEYWORD_RANKINGS, {
    variables: {
      clientId,
      locationId: locationId ?? null,
      keywords: filters?.keywords,
      startDate: filters?.startDate,
      endDate: filters?.endDate,
    },
    skip: !clientId,
  })
  return { rankings: data?.keywordRankings ?? [], loading, error }
}
